/**
 * Header — ported from oakallow-admin/components/Header.tsx verbatim.
 * Only the sign-out redirect target is unchanged — /auth/logout is served
 * by the Hono worker now instead of the Next.js route handler, but the URL
 * and behavior are identical.
 */

import { useState } from 'react';
import { Eye, LogOut, Moon, Sun } from 'lucide-react';

type Theme = 'light' | 'dark' | 'high-contrast';

export default function Header() {
  const [showThemeMenu, setShowThemeMenu] = useState(false);

  const handleTheme = (theme: Theme) => {
    document.documentElement.classList.remove('dark', 'high-contrast');
    if (theme === 'dark') document.documentElement.classList.add('dark');
    else if (theme === 'high-contrast') document.documentElement.classList.add('high-contrast');
    localStorage.setItem('theme', theme);
    setShowThemeMenu(false);
  };

  const handleSignOut = () => {
    window.location.href = '/auth/logout';
  };

  return (
    <div className="dashboard-header-controls">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <div style={{ position: 'relative' }}>
          <button
            onClick={() => setShowThemeMenu(!showThemeMenu)}
            className="btn btn-secondary btn-sm"
            aria-label="Change theme"
          >
            <Sun size={16} />
          </button>
          {showThemeMenu && (
            <div
              style={{
                position: 'absolute',
                right: 0,
                top: '100%',
                marginTop: '0.25rem',
                background: 'var(--bg-primary)',
                border: '1px solid var(--border-color)',
                borderRadius: 'var(--radius-md)',
                boxShadow: 'var(--card-shadow)',
                overflow: 'hidden',
                zIndex: 50,
                minWidth: 140,
              }}
            >
              {[
                { theme: 'light' as Theme, icon: Sun, label: 'Light' },
                { theme: 'dark' as Theme, icon: Moon, label: 'Dark' },
                { theme: 'high-contrast' as Theme, icon: Eye, label: 'High Contrast' },
              ].map(({ theme, icon: Icon, label }) => (
                <button
                  key={theme}
                  onClick={() => handleTheme(theme)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.5rem 0.75rem',
                    width: '100%',
                    border: 'none',
                    background: 'none',
                    color: 'var(--text-primary)',
                    cursor: 'pointer',
                    fontSize: '0.8rem',
                  }}
                >
                  <Icon size={14} /> {label}
                </button>
              ))}
            </div>
          )}
        </div>
        <button
          onClick={handleSignOut}
          className="btn btn-secondary btn-sm"
          aria-label="Sign out"
        >
          <LogOut size={16} />
        </button>
      </div>
    </div>
  );
}
